import { createTheme } from '@mui/material';
import { Theme } from '@mui/material/styles';
import type {} from '@mui/lab/themeAugmentation';
import { COLORADO_TENANT_ID } from './constants';
import { getTenantIdForDomain } from '../helpers/tenantHelpers';

const createTenantTheme = (tenantId: string): Theme => {
  let primaryColor = '#be051b';

  if (tenantId === COLORADO_TENANT_ID) {
    primaryColor = '#269068';
  }

  return createTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: '#FFF',
      },
      // type: 'light',
      text: {
        primary: '#000',
        secondary: '#000',
        disabled: '#666666',
      },
      warning: {
        main: '#000',
      },
    },
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: {
            color: "#be051b",
          },
        }
      },
    },
  });
};

const theme: Theme = createTenantTheme(getTenantIdForDomain());

export default theme;
